import { render } from "./BarcodeSymbologiesSelection.vue?vue&type=template&id=55143a8a&scoped=true"
import script from "./BarcodeSymbologiesSelection.vue?vue&type=script&lang=ts"
export * from "./BarcodeSymbologiesSelection.vue?vue&type=script&lang=ts"

import "./BarcodeSymbologiesSelection.vue?vue&type=style&index=0&id=55143a8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55143a8a"

export default script